/** --------------------------------------------------
* 
*   product tooltips
*
*   TABLE OF CONTENTS
*   document ready
*
*  -------------------------------------------------- */

(function($) {

"use strict";




/** --------------------------------------------------
*   #document ready
*   -------------------------------------------------- */

$(document).ready(function() {

	/* anchor link */
	/* *********** */

	const $colorBlock = $('.paragraph--type--color-list').first();
	if($colorBlock.length > 0) {
		$colorBlock.attr('id', 'product-colors');
	}

	$(document).on('click.productColorScroll', '.series-color-list-itemlink', function(e) {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

			if (target.length) {

				let scrollOffset = target.offset().top;

				// -> if sticky product header is shown at the top:
				const $stickyProductHeader = $('.sticky-header-wrapper');
				if($stickyProductHeader.length > 0) {
					const stickyProductHeader = $stickyProductHeader[0];
					const stickyStyles = window.getComputedStyle(stickyProductHeader);
					const topPosition = stickyStyles.getPropertyValue('top');
					if(topPosition === '0px') {
						const stickyHeaderHeight = $stickyProductHeader.outerHeight();
						scrollOffset -= stickyHeaderHeight;
					}
				}

				$('html, body').on('mousedown wheel DOMMouseScroll mousewheel touchmove', function(){
					$('html, body').stop();
				});
	
				$('html, body').animate({
					scrollTop: scrollOffset
				}, 1000, function() {
					$('html, body').off('mousedown wheel DOMMouseScroll mousewheel touchmove');
				});

				return false;
			}

		}
	});

	/* tooltip */
	/* ******* */

	tippy('.series-color-list-itemlink', {
		a11y: true,
		animation: 'fade',
		arrow: true,
		arrowType: 'sharp',
		delay: [0, 20],
		duration: [275, 250],
		distance: 10,
		maxWidth: 280,
		theme: 'productcolor',
		placement: 'top-start'
	});

});




})(jQuery);
